import { IconProps } from '../icon';

export function AlignementDroiteIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 208.02" {...props}>
      <g id="a" />
      <g id="b">
        <g id="c">
          <g>
            <path d="M127.93,15.69c-38.51,0-77.02,0-115.53,0-1.83,0-3.69,.09-5.48-.21C2.59,14.75-.09,12.18,0,7.68,.09,3.17,2.98,.82,7.24,.14c1.47-.23,2.99-.09,4.49-.09,77.52,0,155.04,0,232.56,0,7.98,0,11.63,2.42,11.7,7.73,.07,5.27-3.75,7.91-11.54,7.91-38.84,0-77.69,0-116.53,0Z" />
            <path d="M127.47,144.05c-38.67,0-77.35,0-116.02,0-1.67,0-3.39,.19-4.99-.14-4.06-.86-6.55-3.44-6.45-7.67,.1-4.17,2.47-6.8,6.71-7.37,1.81-.24,3.66-.19,5.49-.19,77.18,0,154.37,0,231.55,0,1.83,0,3.68-.06,5.49,.19,4.24,.57,6.6,3.21,6.7,7.38,.1,4.23-2.4,6.81-6.46,7.66-1.6,.34-3.32,.14-4.99,.14-39.01,0-78.02,0-117.02,0Z" />
            <path d="M164.5,79.38c-26.5,0-53,0-79.51,0-1.67,0-3.34,.05-5-.07-4.61-.35-7.77-3.41-7.85-7.47-.08-4.24,3.31-7.54,8.08-7.82,1.16-.07,2.33-.02,3.5-.02,53.67,0,107.34,0,161.01,0,1.67,0,3.4-.22,4.98,.17,4.01,.99,6.44,3.63,6.22,7.88-.2,3.93-2.45,6.49-6.45,7.1-1.8,.27-3.66,.23-5.49,.23-26.5,.01-53,0-79.51,0Z" />
            <path d="M193.5,208c-16.84,0-33.68,.02-50.52-.03-1.81,0-3.69-.1-5.4-.62-3.61-1.1-5.55-3.88-5.35-7.54,.2-3.62,2.29-6.24,6.03-7.03,1.61-.34,3.3-.42,4.96-.42,34.01-.02,68.02-.02,102.03-.01,1,0,2.01-.04,3,.08,4.65,.53,7.7,3.54,7.76,7.63,.07,4.34-3.09,7.5-7.99,7.91-1.33,.11-2.67,.04-4,.04-16.84,0-33.68,0-50.52,0Z" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default AlignementDroiteIcon;
